import { render, staticRenderFns } from "./EmailEditor.vue?vue&type=template&id=0004a438&scoped=true&"
import script from "./EmailEditor.vue?vue&type=script&lang=js&"
export * from "./EmailEditor.vue?vue&type=script&lang=js&"
import style0 from "./EmailEditor.vue?vue&type=style&index=0&id=0004a438&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0004a438",
  null
  
)

export default component.exports